import { AnyIfEmpty } from 'react-redux';
import {
    GET_STATE_LANDMARK_REQUEST,
    GET_STATE_LANDMARK_SUCCESS,
    GET_STATE_LANDMARK_FAILURE,
    GET_UNITS_REQUEST,
    GET_UNITS_SUCCESS,
    GET_UNITS_FAILURE,
} from '../constants/landmark.constants';

const initialState = {
    loading: false,
    data: [],
    locationUnits: null,
    errorMsg: '',
};

const landmarkReducer = (state = initialState, action: { type: string; payload: AnyIfEmpty<object> }) => {
    switch (action.type) {
        //Get locations

        case GET_STATE_LANDMARK_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                locationUnits: null,
                errorMsg: '',
            };
        case GET_STATE_LANDMARK_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_STATE_LANDMARK_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        //Get units

        case GET_UNITS_REQUEST:
            return {
                ...state,
                loading: true,
                locationUnits: null,
                errorMsg: '',
            };
        case GET_UNITS_SUCCESS:
            return {
                ...state,
                loading: false,
                locationUnits: action.payload,
            };
        case GET_UNITS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        default:
            return state;
    }
};

export default landmarkReducer;
